module.exports = __webpack_public_path__ + "img/logo.0ca86b76.png";